import { useState } from 'react';
import { LargeTitleHeader } from '@/components/common';

// ── Client portal help (portal audit: the Account page linked clients to the
// EMPLOYEE help page, which bounced them back home) ─────────────────────────

const FAQS: { q: string; a: string }[] = [
  { q: 'How do I pay an invoice?', a: 'Open Invoices from the bottom bar and tap "Pay Now" on any outstanding invoice — you\'ll pay securely by card and get an emailed receipt right away. Prefer e-Transfer? Send it to billing@ochrepoint.ca with the invoice number in the message.' },
  { q: 'How do I approve a quote?', a: 'When we send you a quote you\'ll get an email with a "Review & Approve" button, and it also appears on your portal home. Open it to see the full breakdown, then approve or decline — we\'re notified instantly either way.' },
  { q: 'Where are my documents and contracts?', a: 'The Docs tab holds everything we\'ve shared with you: agreements, plans, permits and photos. Agreements waiting for your signature have a "Review & sign" button.' },
  { q: 'When is the crew coming?', a: 'The Schedule tab shows every upcoming visit with the date, time and site address (tap the address for directions). You can also add the schedule to your own calendar with "Sync to my calendar".' },
  { q: 'How do I ask a question or request a change?', a: 'Tap "Message" on your home screen — it goes straight to our inbox and dashboard. Or call us at (250) 510-0677, or email info@ochrepoint.ca.' },
  { q: 'I forgot my password.', a: 'On the sign-in screen tap "Forgot password?" and enter your email — we\'ll send you a secure link to set a new one. The link works once and expires after 24 hours.' },
  { q: 'Can I use this like an app on my phone?', a: 'Yes — open the portal in your phone\'s browser, then choose "Add to Home Screen" (Share menu on iPhone, browser menu on Android). It installs with the OchrePoint icon and works like an app.' },
  { q: 'Is my information private?', a: 'Yes. You only ever see your own projects, invoices and documents, payments run through Stripe (we never see your card number), and nothing is shared without your say-so.' },
];

export const ClientHelpPage = () => {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="space-y-4 pb-6">
      <LargeTitleHeader title="Help & FAQ" subtitle="Quick answers — and real humans a tap away" />

      <div className="bg-white rounded-2xl border border-gray-200 divide-y divide-gray-50">
        {FAQS.map((f, i) => (
          <div key={i}>
            <button onClick={() => setOpen(open === i ? null : i)}
              className="w-full flex items-center gap-3 px-4 py-3.5 text-left">
              <span className="flex-1 text-sm font-semibold text-gray-800">{f.q}</span>
              <span className={`material-symbols-outlined text-gray-300 transition-transform ${open === i ? 'rotate-180' : ''}`}>expand_more</span>
            </button>
            {open === i && <p className="px-4 pb-4 text-sm text-gray-600 leading-relaxed">{f.a}</p>}
          </div>
        ))}
      </div>

      <div className="bg-[#C77D3F]/10 border border-[#C77D3F]/30 rounded-2xl p-4 text-center space-y-2">
        <p className="text-sm font-semibold text-[#7a4a22]">Still stuck? We're local and we answer.</p>
        <div className="flex gap-2 justify-center">
          <a href="tel:+12505100677" className="flex items-center gap-1.5 px-4 py-2 rounded-xl bg-[#C77D3F] text-white text-sm font-bold active:scale-95">
            <span className="material-symbols-outlined text-base">phone</span> (250) 510-0677
          </a>
          <a href="mailto:info@ochrepoint.ca" className="flex items-center gap-1.5 px-4 py-2 rounded-xl border border-[#C77D3F]/40 text-[#8a5526] text-sm font-bold active:scale-95">
            <span className="material-symbols-outlined text-base">mail</span> Email
          </a>
        </div>
      </div>
    </div>
  );
};
